export enum WindowEventType {
  FromBackgroundScript = 'FROM_BACKGROUND_SCRIPT',
  FromContentScript = 'FROM_CONTENT_SCRIPT',
  FromContentScriptBridgeData = 'FROM_CONTENT_SCRIPT_BRIDGE_DATA',
  FromDashboard = 'FROM_DASHBOARD',
  FromInjectedScript = 'FROM_INJECTED_SCRIPT',
  FromPage = 'FROM_PAGE',
  FromPageEventData = 'FROM_PAGE_EVENT_DATA',
  Graph = 'graph',
}
